import { Component, OnInit } from '@angular/core';
import { GamesGroupService, GroupType, PredictorGroupSummary } from '@fgb/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'fgb-predictor-page',
  templateUrl: './predictor-page.component.html',
  styleUrls: ['./predictor-page.component.scss'],
})
export class PredictorPageComponent implements OnInit {
  gamesGroup$: Observable<PredictorGroupSummary[]>;
  groupType = GroupType.Predictor;

  constructor(private gamesGroupService: GamesGroupService) {}

  ngOnInit() {
    this.gamesGroup$ = this.gamesGroupService.fetchPredictorGroups();
  }
}
